import { render, staticRenderFns } from "./Retards.vue?vue&type=template&id=4c8e2632&scoped=true"
import script from "./Retards.vue?vue&type=script&lang=js"
export * from "./Retards.vue?vue&type=script&lang=js"
import style0 from "./Retards.vue?vue&type=style&index=0&id=4c8e2632&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8e2632",
  null
  
)

export default component.exports